import React from "react";
import { BaselineReadPopup, valueStrings, BaselineStrings } from "constants/constantStrings";
import "./index.scss";
import PopoverText from "../../components/PopoverText";
import { useSelector } from "react-redux";

const BaselineReadMore = () => {
  const { isAdmin } = useSelector(state => state.user);

  const getDesc = () => {
    return (
      <div>
        <h1>{BaselineReadPopup.createNewBaseline}</h1>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {BaselineReadPopup.baselineTitle}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {BaselineReadPopup.newbaseline}
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {BaselineReadPopup.baselineViaTimestamp}
          <span className="descriptionBold">{BaselineReadPopup.timestampNote}</span>
          {BaselineReadPopup.baselineViaTimestampSecond}
        </div>
        <div className="description">
          <span className="descriptionBold"> &#8226;&nbsp;</span>
          {BaselineReadPopup.retriveDataText1}&nbsp;<span className="underline">{BaselineReadPopup.retriveData}</span>&nbsp;
          {BaselineReadPopup.retriveDataText1}&nbsp;
          <span className="underline">
            {BaselineReadPopup.addNewBaseLine}&nbsp;{BaselineReadPopup.button}
          </span>
          <span className="descriptionBold">&nbsp;{BaselineReadPopup.retriveDataText3}</span>
        </div>
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {BaselineReadPopup.addNewBaselineText1}&nbsp;
          <span className="underline">
            {BaselineReadPopup.addNewBaseLine}&nbsp;{BaselineReadPopup.button}
          </span>
        </div>
        {isAdmin && (
          <div className="description">
            <span className="descriptionBold">&#8226;&nbsp;</span>
            {BaselineReadPopup.editTags}
            <span className="descriptionBold">{BaselineReadPopup.pressSaveButton}</span>
          </div>
        )}
        <div className="description">
          <span className="descriptionBold">&#8226;&nbsp;</span>
          {BaselineReadPopup.saveButtons}&nbsp;<span className="underline">{BaselineReadPopup.saveAndAdd}</span>&nbsp;{BaselineReadPopup.closePopup}
        </div>
      </div>
    );
  };

  return (
    <>
      <span className="descriptionText">{BaselineStrings.enterBelowValue}</span>
      <PopoverText descriptor={valueStrings.here} descriptionText={getDesc()} customClass="summary-content" />
    </>
  );
};

export default BaselineReadMore;
